import styled, { css } from 'styled-components';
import { xdlColorTextOnDark } from '@xingternal/tokens';
// *** Variants ***
export const variants = {
    positive: css `
    color: #006567;
  `,
    greyscale: css `
    color: #333333;
  `,
    duo: null,
    mono: null,
};
// *** Components ***
const XingLogo = styled.div ``;
const OldSvg = styled.svg `
  ${({ $variant, $inverted }) => $variant && !$inverted && variants[$variant]}
  ${({ $inverted }) => $inverted &&
    css `
      color: ${xdlColorTextOnDark};
    `}
`;
const Svg = styled.svg `
  display: block;
`;
export const Styled = {
    OldSvg,
    Svg,
    XingLogo,
};
//# sourceMappingURL=xing-logo.styles.js.map